module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  }), _vm._v(" "), _c('scroller', {
    ref: "helpListScroller",
    attrs: {
      "on-refresh": _vm.refresh,
      "on-infinite": _vm.infinite
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px",
      "font-size": "14px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.user.name) + "(" + _vm._s(_vm.user.phone) + ")"), _c('em', {
    staticClass: "logout",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("[更换账号]")])]), _vm._v(" "), _c('van-notice-bar', {
    attrs: {
      "scrollable": true
    }
  }, [_vm._v("\n             以下是您报名成功记录，仅用于信息核对\n        ")]), _vm._v(" "), (_vm.list && _vm.list.length > 0) ? _c('div', {
    staticClass: "help-list"
  }, _vm._l((_vm.list), function(item) {
    return _c('router-link', {
      key: item.id,
      staticClass: "help-item",
      attrs: {
        "tag": "div",
        "to": {
          name: 'saiConfirm',
          query: {
            'id': item.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(item.mingcheng) + "\n                    ")]), _vm._v(" "), _c('p', {
      staticClass: "item-time"
    }, [_vm._v(_vm._s(item.sqname))])])
  }), 1) : _c('div')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2406b358","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/sai/SaiConfirmManage.vue
// module id = 1410
// module chunks = 0